import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_DETAIL_PHIEU_THUCHI,
  GET_IN_PHIEU_THUCHI,
} from "actions/InThuChi/actionTypes";
import {
  getDetailPhieuThuChiSuccess,
  getDetailPhieuThuChiFailure,
  getInPhieuThuChiSuccess,
  getInPhieuThuChiFailure,
} from "actions/InThuChi";
import { pushNotification } from "utils/notifications";
import InThuChiApi from "service/inThuChiApi";

function* getDetailPhieuThuChi(action) {
  try {
    const response = yield call(InThuChiApi.detail, action.dataSearch);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(getDetailPhieuThuChiFailure());
      } else {
        yield put(getDetailPhieuThuChiSuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getDetailPhieuThuChiFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getDetailPhieuThuChiFailure());
  }
}
function* getInPhieuThuChi(action) {
  try {
    const response = yield call(InThuChiApi.getInThuChi, action.dataSearch);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(getInPhieuThuChiFailure());
      } else {
        yield put(getInPhieuThuChiSuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getInPhieuThuChiFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getInPhieuThuChiFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_DETAIL_PHIEU_THUCHI, getDetailPhieuThuChi);
  yield takeLatest(GET_IN_PHIEU_THUCHI, getInPhieuThuChi);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
